import styled from 'styled-components';

//enagement userlist page style
const Headerbody = styled.section`
	// common for table UI start
	.editPermissions-modal {
		width: 30%;
		max-width: 30%;
		height: auto;
	}

	.wrapper-engagementbase {
		background: var(--neutrals-bg-gradient1);
	}

	.pageheading {
		display: flex;
		padding: var(--spacing-x-large) 0;
		align-items: end;
		justify-content: space-between;

		.motif-tooltip-wrapper {
			.motif-button {
				&[disabled] {
					pointer-events: none;
				}
			}
		}
	}

	.pagerholder {
		width: calc(100vw - var(--px-80));
		margin: 0 auto;
		max-width: 2048px;
		display: flex;
		padding: var(--px-24) 0;

		.engagement-paging {
			font-size: var(--px-14);
			justify-content: flex-end;

			.Dropdown-arrow {
				margin-top: var(--px-3);
			}
		}
	}

	.adduser-modal {
	}
	.edit-user {
	}

	.userlistwrapper {
		width: 100%;
		display: inline-grid;

		.manageaccessitemview {
			width: 100%;
			display: flex;
			border-collapse: collapse;
			align-items: center;
			justify-content: center;
			border-bottom: var(--px-1) solid var(--neutrals-200);
			border-radius: 0 0 var(--px-8) var(--px-8);

			&.inactive mgt-person {
				color: var(--neutrals-300);
			}

			&:not(.inactive) .userName {
				color: var(--neutrals-900);
			}

			.grid {
				display: grid;
				grid-template-columns: auto 1fr;
				grid-gap: 0 10px;
			}

			&:last-child {
				border-bottom: none !important;
			}
		}

		.userlist-header {
			width: 100%;
			display: inline-block;
			.editicon {
				width: 4%;
				padding: var(--px-10);
				vertical-align: middle;
			}
			.userlistheader {
				width: 100%;
				color: var(--neutrals-700);
				font-weight: bold;
				display: flex;
				border-collapse: collapse;
				background: var(--neutrals-50);
				border: var(--px-1) solid var(--neutrals-200);
				height: var(--px-48);
				border-radius: var(--px-8) var(--px-8) 0 0;
				border-bottom: none;
			}
		}

		.engagement-userlist-body {
			width: 100%;
			height: calc(100vh - var(--px-500));
			display: inline-block;
			border: var(--px-1) solid var(--neutrals-200);
			border-radius: 0 0 var(--px-8) var(--px-8);
			background: var(--neutrals-00white);
			.manageaccessitemview {
				border-bottom: var(--px-1) solid var(--neutrals-200);
				height: var(--px-48);
			}

			.editicon-button {
				width: 4%;
				.motif-tooltip-wrapper {
					width: auto !important;
				}
			}

			.userlistholder {
				.motif-tooltip-wrapper {
					width: 100%;
					.motif-tooltip-trigger-wrap {
						width: 100%;
						display: inline-block;

						.react-select__single-value {
							padding: 0;
						}
					}
				}
			}
		}

		.userlist-header,
		.engagement-userlist-body {
			.userlistitem {
				padding: 0 var(--spacing-large);
				flex: 1 1 auto;
				width: 10%;
				vertical-align: middle;
				display: flex;
				align-items: center;
				&.date,
				&.status {
					width: 6%;
				}

				&.status {
					&.postarchiveactive {
						.ellipses {
							width: auto;
							max-width: 48%;
						}
					}

					&.nopostarchiveactive {
						.postarchive {
							display: none;
						}
					}

					.ellipses {
						display: inline-flex;
						width: 100%;
						margin-right: var(--px-10);
					}

					.postarchive {
						display: inline-flex;
					}
				}

				&.userName,
				&.emailAddress {
					width: 18%;
				}
				&.permission {
					width: 16%;
				}
				&.adstatus,
				&.gui,
				&.status {
					width: 8%;
				}

				&.permission {
					.pic {
						margin: 0 var(--px-11) 0 var(--px-6);
						line-height: normal;
						display: inline-flex;
						align-items: center;
						.picflag {
							font-weight: bold;
							font-size: var(--px-12);
							color: var(--green-400);
						}
					}
					.permission-badge {
						cursor: pointer;
					}
					.motif-dropdown-menu {
						margin: var(--px-24) 0;
					}
					.motif-dropdown-group {
						padding: 0;
						gap: 0;
						border-bottom: var(--px-1) solid var(--neutrals-300);

						&:last-child {
							border-bottom: 0;
						}
					}
					.motif-dropdown-group-title {
						padding: var(--px-5) var(--px-8);
						margin: 0;
					}
					.motif-dropdown-item {
						padding: var(--px-5) var(--px-8);
						gap: 0;
						font-size: var(--px-14);
						font-weight: 300;
						line-height: var(--px-20);
						border: none;
						text-decoration: none;
						outline: none;
						background-color: unset;
					}
					.motif-dropdown-item:focus {
						border: none;
					}
					.permissionlist {
						border: none;
					}
				}

				.e-country-dd .react-select__control {
					min-height: var(--px-44);
				}

				.permission-list {
					button {
						border: 0;
						background: none;

						.motif-badge {
							svg {
								vertical-align: text-top;
							}
						}
					}
					.show-pop-content {
						margin: var(--px-20) 0 var(--px-25) 0;
						width: var(--px-200);
						box-shadow: unset;
						right: 0;
						left: auto;
						.showPopupWrapper {
							width: var(--px-200);
						}
						&.left {
							left: 0;
						}
						&.right {
							right: 0;
						}
						&.top {
							bottom: var(--px-10);
						}
						.checklist {
							ul {
								line-height: normal;
								margin: 0 !important;
								a {
									color: var(--neutrals-700);
									font-weight: normal;
									text-decoration: none;
									padding: var(--px-10);
									width: 100%;
									display: inline-block;
									font-size: var(--px-14);
								}
							}
							li {
								color: var(--neutrals-700);
								font-weight: normal;
								text-decoration: none;
								width: 100%;
								display: inline-block;
								font-size: var(--px-14);
							}
						}
					}
				}
				.motif-badge {
					margin-right: var(--px-5);
				}
				.motif-badge-alt {
					background-color: var(--neutrals-900);
					color: var(--neutrals-00white);
				}
			}
		}
	}

	// common for table UI end
`;

export default Headerbody;
